import { render, staticRenderFns } from "./CompanyWalletUndistributeUserPointSearchResultBeautify.vue?vue&type=template&id=056b3d48&scoped=true"
import script from "./CompanyWalletUndistributeUserPointSearchResultBeautify.vue?vue&type=script&lang=js"
export * from "./CompanyWalletUndistributeUserPointSearchResultBeautify.vue?vue&type=script&lang=js"
import style0 from "./CompanyWalletUndistributeUserPointSearchResultBeautify.vue?vue&type=style&index=0&id=056b3d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b3d48",
  null
  
)

export default component.exports